import * as React from 'react';
import { SocialSectionDataProps } from './FooterSocialLinks';
import { FooterMobileStoresBaseProps } from './FooterMobileStores';
import { AdditionalFooterSections } from './AdditionalFooterSections';

export const getAdditionalFooterSection = (socialSection: SocialSectionDataProps | null, appsSection: FooterMobileStoresBaseProps | null, separatorColor: string, separatorHeight: number) => {
  if (socialSection === null && appsSection === null) return null;
  return <AdditionalFooterSections key="additional-links" socialSection={socialSection} appsSection={appsSection} separatorColor={separatorColor} separatorHeight={separatorHeight} />;
};
